export default {
  install(Vue, authInfo) {
    Vue.prototype["$authInfo"] = authInfo;
  },
};
